"use client";

import { LoginRegistrationLayout } from "@/app/component/Landing";
import { useClientConfigProvider } from "@/app/config/client-config-provider";
import { EventLabels } from "@/app/constants/mix-panel-enums";
import { useMixPanel } from "@/app/context/mixPanelContext";
import { ReactNode, useEffect } from "react";

export default function RegisterLoginLayoutV1({
  children,
}: Readonly<{
  children: ReactNode;
}>) {
  const { config, getImagePath } = useClientConfigProvider();
  const { trackEvent, mixpanelInitialized } = useMixPanel();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const allSearchParams = Object.fromEntries(urlParams.entries());
    trackEvent(EventLabels.SL_Login_Register, {
      screen: "Landing",
      ...(process.env.NEXT_PUBLIC_PROJECT_CODE === `MASTERCARD_CL`
        ? allSearchParams
        : {}),
    });
  }, [mixpanelInitialized]);

  return (
    <div className="section_landing_container section_login_container">
      {<LoginRegistrationLayout>{children}</LoginRegistrationLayout>}
    </div>
  );
}
